import type { Address } from "viem"
import { useParams } from "react-router-dom"

import { MetaData } from "@/domains/common/layout/metadata"
import { PageContainer } from "@/domains/common/layout/page-container"
import { PageTitle } from "@/domains/common/layout/page-title"
import { CL_PRODUCT_COPY } from "@/domains/manual-cl-page/cl-product-copy"
import { MANUAL_CL_V1_BREADCRUMBS } from "@/domains/thick-v1/breadcrumbs"
import { PoolDetailPageComposite } from "@/domains/thick-v1/components/pool-detail/pool-detail-page-composite"

/**
 * Pool detail route — `/liquidity/cl/v1/:address`. Thin routing
 * boilerplate around {@link PoolDetailPageComposite}; the composite owns
 * all store wiring so this page stays trivially renderable in tests.
 */
export default function ManualClPoolDetailPage() {
  const { address: poolAddressParam } = useParams<{ address: string }>()
  const poolAddress = poolAddressParam as Address | undefined
  const title = CL_PRODUCT_COPY.v1.poolTitle

  return (
    <PageContainer>
      <MetaData title={title} />
      <PageTitle title={title} items={MANUAL_CL_V1_BREADCRUMBS} />
      {poolAddress ? <PoolDetailPageComposite poolAddress={poolAddress} /> : null}
    </PageContainer>
  )
}
